import { ValidatorReturnType } from "./FormValidators";
import { withDefault } from "./withDefault";

export type FormControlValidators = ((formControl: FormControl) => ValidatorReturnType)[];

export class FormControl {
  public validators: ((formControl: FormControl) => ValidatorReturnType)[] = [];
  private errors: string[] = [];
  private dirty: boolean = false;

  constructor(public value: string | number | null, validators?: FormControlValidators) {
    this.validators = withDefault(validators, []);
    this.dirty = value !== null;
    this.checkForErrors();
  }

  isEmpty() {
    return this.value === null || this.value.toString() === "";
  }

  isValid(): boolean {
    return this.errors.length === 0;
  }

  isDirty(): boolean {
    return this.dirty;
  }

  hasErrors(): boolean {
    return this.errors.length !== 0;
  }

  getErrors(): string[] {
    return this.isDirty() ? this.errors : [];
  }

  getFirstError(): string | null {
    if (this.isDirty() && this.errors.length > 0) {
      return this.errors[0];
    }

    return null;
  }

  private checkForErrors(): void {
    this.errors = [];

    for (const validator of this.validators) {
      const validate = validator(this);
      const key = Object.keys(validate)[0];
      const value = validate[key];

      if (value) {
        this.errors.push(key);
      }
    }
  }
}
